/**
 * AlmadarPostContextCompactionSLPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostContextCompactionSLPostPage
 */

import { useAlmadarPostContextCompactionSLPostPageLogic } from '@/hooks/traits/useAlmadarPostContextCompactionSLPostPageLogic';
import type { AlmadarPostContextCompactionSLPostPageConfig } from '@/hooks/traits/useAlmadarPostContextCompactionSLPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostContextCompactionSLPostView as AlmadarPostContextCompactionSLPostViewEntity } from '@app/shared';
import { Box } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { AlmadarPostContextCompactionSLPostFooterView } from '@/components/traits/AlmadarPostContextCompactionSLPostFooterView';
import { AlmadarPostContextCompactionSLPostHeaderView } from '@/components/traits/AlmadarPostContextCompactionSLPostHeaderView';
import { Stack } from '@almadar/ui/components';
import { AlmadarPostContextCompactionSLPostView } from '@/components/traits/AlmadarPostContextCompactionSLPostView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostContextCompactionSLPostPageViewProps {
  config?: Partial<AlmadarPostContextCompactionSLPostPageConfig>;
}

export function AlmadarPostContextCompactionSLPostPageView({ config: propsConfig }: AlmadarPostContextCompactionSLPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostContextCompactionSLPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostContextCompactionSLPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostContextCompactionSL" trait="AlmadarPostContextCompactionSLPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostContextCompactionSLPostPage">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><AlmadarPostContextCompactionSLPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box bg="transparent" fullWidth={true} paddingY="xl"><Container size="xl" padding="lg" maxWidth="xl"><AlmadarPostContextCompactionSLPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostContextCompactionSLPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostContextCompactionSLPostPageView;
